const size = {
    mobile: '767px',
}
export const device = {
    mobile: `(max-width: ${size.mobile})`,
  };